export default class GoogleTagManagerService {
  public static init(googleTagManagerId: string): void {
    if (typeof window !== 'undefined') {
      (window as WindowExtended).gtmSettings = {
        id: googleTagManagerId,
      };
    }
  }
}
